export const parseNumeric = (value: string | number): number | null => {
  const normalized = String(value).replace(/\s/g, "").replace(",", ".");
  if (!normalized) return null;

  const parsed = Number(normalized);
  return Number.isFinite(parsed) ? parsed : null;
};
